import { IHousingObjectResponse } from '@/types';
import { StructuredData } from '@/types/structuredData';
import { buildListingListItems } from './buildListingListItems';

export const generateSimilarListingsSchema = (
  objects: IHousingObjectResponse[],
  locale: string,
  section: 'housing' | 'project' = 'housing',
): StructuredData => ({
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  name: 'Ähnliche Objekte',
  numberOfItems: objects.length,
  itemListElement: buildListingListItems(objects, locale, section),
});
